// src/admin/components/AdminTable.jsx
import React from 'react';

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  fontFamily: "'DM Sans', sans-serif",
  fontSize: '13px',
};

const thStyle = {
  textAlign: 'left',
  padding: '10px 12px',
  borderBottom: '2px solid rgba(0,0,0,0.08)',
  color: '#6c6c6d',
  fontWeight: 600,
  fontSize: '11px',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
};

const tdStyle = {
  padding: '10px 12px',
  borderBottom: '1px solid rgba(0,0,0,0.05)',
  color: '#1d1d1f',
};

export default function AdminTable({ columns, rows, loading, emptyMessage = 'Nessun risultato', onRowClick, getRowKey }) {
  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#6c6c6d', fontSize: '13px' }}>
        Caricamento...
      </div>
    );
  }

  if (!rows || rows.length === 0) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#6c6c6d', fontSize: '13px' }}>
        {emptyMessage}
      </div>
    );
  }

  return (
    <table style={tableStyle}>
      <thead>
        <tr>
          {columns.map(col => (
            <th key={col.key} style={{ ...thStyle, ...(col.width ? { width: col.width } : {}) }}>
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => {
          const key = getRowKey ? getRowKey(row, i) : (row.user_id || row.id || i);
          return (
            <tr
              key={key}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
              style={{
                cursor: onRowClick ? 'pointer' : 'default',
                background: i % 2 === 0 ? 'transparent' : 'rgba(0,0,0,0.015)',
                transition: 'background 0.1s',
              }}
              onMouseEnter={e => { if (onRowClick) e.currentTarget.style.background = 'rgba(232,0,45,0.04)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = i % 2 === 0 ? 'transparent' : 'rgba(0,0,0,0.015)'; }}
            >
              {columns.map(col => (
                <td key={col.key} style={tdStyle}>
                  {col.render ? col.render(row) : row[col.key]}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
